<template>
  <template v-if="type !== 'password'">
    <IconField
      v-if="$slots.prepend || $slots.append"
      data-sb-automation="sb-text-input-with-slots"
    >
      <InputIcon
        v-if="$slots.prepend"
        ref="prepend-slot"
        :class="[$style.inputFontSize]"
        data-sb-automation="sb-text-input-prepend"
      >
        <slot name="prepend" />
      </InputIcon>
      <InputText
        v-bind="$attrs"
        ref="inputRef"
        :type="type"
        :class="[
          $style.inputHeight,
          $style.borderWidth,
          $style.border,
          $style.fullWidth,
          $style.inputFontSize,
        ]"
        :data-sb-automation="$attrs['data-sb-automation'] || 'sb-text-input'"
        data-sb-regression="sb-text-input"
      />
      <InputIcon
        v-if="$slots.append"
        :class="[$style.inputFontSize]"
        data-sb-automation="sb-text-input-append"
      >
        <slot name="append" />
      </InputIcon>
    </IconField>
    <InputText
      v-else
      v-bind="$attrs"
      ref="inputRef"
      data-sb-regression="sb-text-input"
      :type="type"
      :class="[$style.inputHeight, $style.inputFontSize, $style.borderWidth]"
      :data-sb-automation="$attrs['data-sb-automation'] || 'sb-text-input'"
    />
  </template>
  <Password
    v-else
    v-bind="$attrs"
    ref="inputRef"
    data-sb-regression="sb-text-password-input"
    :model-value="$attrs.value"
    :class="[$style.fullWidth]"
    :toggle-mask="showPassword"
    :pt="{
      maskIcon: {
        class: $style.maskIcon
      },
      unmaskIcon: {
        class: $style.maskIcon
      }
    }"
    :feedback="false"
    :input-class="[
      $style.inputHeight,
      $style.inputFontSize,
      $style.fullWidth,
      $style.borderWidth,
      $style.passwordInput
    ]"
    :data-sb-automation="$attrs['data-sb-automation'] || 'sb-text-input-password'"
  />
</template>

<script setup>
import InputText from 'primevue/inputtext';
import Password from 'primevue/password';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';

import { defineProps, defineOptions, defineExpose, ref } from 'vue';

const inputRef = ref(null);
defineOptions({
  name: 'SbTextInputNext',
});

const props = defineProps({
  type: {
    type: String,
    default: () => 'text',
  },
  showPassword: {
    type: Boolean,
    default: () => false,
  },
});
function blurInput() {
  if (props.type !== 'password') {
    inputRef.value?.$el?.blur();
  } else {
    inputRef.value?.$el?.querySelector('input')?.blur();
  }
}

function focusInput() {
  if (props.type !== 'password') {
    inputRef.value?.$el?.focus();
  } else {
    inputRef.value?.$el?.querySelector('input')?.focus();
  }
}

defineExpose({
  focus() {
    focusInput();
  },
  blur() {
    blurInput();
  },
});
</script>

<style lang="scss" module>
@import '@src/components/Input/style/sb-input.module.scss';
</style>
